/*
 * blogsReducer.js
 * trt_cms2
 *
 * Created by Hisyam on 27/2/2020.
 * Copyright (c) 2020 Terato Tech. All rights reserved.
 */

import {
  ADD_POST, ADD_POST_CATEGORY_FROM_SELECT, ADD_POST_CATEGORY_FROM_SELECT_FULFILLED,
  ADD_POST_FULFILLED, ADD_POST_TAG_FROM_SELECT, ADD_POST_TAG_FROM_SELECT_FULFILLED,
  DELETE_POST,
  DELETE_POST_FULFILLED,
  FETCH_POST,
  FETCH_POST_FULFILLED,
  FETCH_POSTS,
  FETCH_POSTS_FULFILLED,
  NEW_POST,
  NEW_POST_FULFILLED,
  RESET_REDIRECT_POST,
  UPDATE_POST,
  UPDATE_POST_FULFILLED
} from "../types";

const initial_posts = {
  "isLoading": false,
  "redirect": false,
  "error": null,
  "limit": 10,
  "offset": 0,
  "count": 0,
  "results": [],
  "post": {},
  "categories": [],
  "tags": [],
  "author": [],
  "creatableSelect": {
    "isLoading": false,
    "categories": [],
    "tags": []
  }
};

export const postsReducer = (state = initial_posts, action) => {
  switch (action.type) {
    case FETCH_POSTS:
      return {
        ...state,
        isLoading: true,
        limit: action.payload.limit,
        offset: action.payload.offset
      };

    case FETCH_POSTS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        count: action.payload.count,
        results: action.payload.results,
      };

    case FETCH_POST:
    case ADD_POST:
    case UPDATE_POST:
    case DELETE_POST:
      return {
        ...state,
        isLoading: true,
      };

    case NEW_POST:
      return {
        ...state,
        creatableSelect: {
          ...state.creatableSelect,
          isLoading: false,
        }
      };

    case NEW_POST_FULFILLED:
      return {
        ...state,
        isLoading: false,
        creatableSelect: {
          ...state.creatableSelect,
          isLoading: false,
          categories: action.payload.categories,
          tags: action.payload.tags
        },
        author: action.payload.author
      };

    case FETCH_POST_FULFILLED:
      return {
        ...state,
        isLoading: false,
        post: {
          ...state.post,
          [action.payload.post.id]: action.payload.post
        },
        creatableSelect: {
          ...state.creatableSelect,
          isLoading: false,
          categories: action.payload.categories,
          tags: action.payload.tags
        },
        author: action.payload.author
      };

    case ADD_POST_FULFILLED:
    case UPDATE_POST_FULFILLED:
      return {
        ...state,
        redirect: true,
        isLoading: false,
        post: {
          ...state.post,
          [action.payload.id]: action.payload
        }
      };

    case DELETE_POST_FULFILLED:
      return {
        ...state,
        redirect: true,
        isLoading: false,
        post: Object.keys(state.post)
          .filter(key => key !== String(action.payload))
          .reduce((obj, key) => obj[key] = state.post[key], {})
      };

    case RESET_REDIRECT_POST:
      return {
        ...state,
        redirect: false,
      };

    case ADD_POST_CATEGORY_FROM_SELECT:
    case ADD_POST_TAG_FROM_SELECT:
      return {
        ...state,
        creatableSelect: {
          ...state.creatableSelect,
          isLoading: true
        }
      };

    case ADD_POST_CATEGORY_FROM_SELECT_FULFILLED:
      return {
        ...state,
        creatableSelect: {
          ...state.creatableSelect,
          isLoading: false,
          categories: [...state.creatableSelect.categories, action.payload]
        }
      };

    case ADD_POST_TAG_FROM_SELECT_FULFILLED:
      return {
        ...state,
        creatableSelect: {
          ...state.creatableSelect,
          isLoading: false,
          tags: [...state.creatableSelect.tags, action.payload]
        }
      };

    default:
      return state;
  }
};